import type { GivingInterval } from 'models';
import { useTranslation } from 'react-i18next';
import { Col, Icon, Row, Text, useFormatPrice } from 'ui';
import { useUser } from 'features/auth';
import { useSubscriptionPlans } from '../../hooks';

type P = {
  amount: number;
  displayName: boolean;
  recurring?: GivingInterval;
  type?: 'giveNow';
};

const GivingSummaryDetails = ({ amount, displayName, recurring, type }: P) => {
  const user = useUser({ requiredAuth: false });
  const { t } = useTranslation();
  const formatPrice = useFormatPrice();
  const { changeIntervalToText, getTranslate } = useSubscriptionPlans();
  const displayInfoLabel = user?.railsUserData
    ? 'Display my name and photo with my gift'
    : 'Display my name with my gift';
  const doNotDisplayInfoLabel = user?.railsUserData
    ? 'Do not display my name and photo with my gift'
    : 'Do not display my name with my gift';

  return (
    <Row gutter={[0, 'xs']}>
      <Col span={24}>
        <Row align="middle" gutter={['ms', 0]}>
          <Col>
            <Icon icon="hand-heart-line" size="medium-small" />
          </Col>
          <Col>
            <Text weight="medium">{formatPrice({ value: amount })}</Text>
          </Col>
        </Row>
      </Col>
      {type === 'giveNow' ? null : (
        <Col span={24}>
          <Row align="middle" gutter={['ms', 0]}>
            <Col>
              <Icon icon="exchange-dollar-line" size="medium-small" />
            </Col>
            <Col>
              {recurring ? (
                <>
                  <Text weight="medium">{getTranslate(recurring)}</Text>
                  <br />
                  <Text size="small">
                    {t('recurringPaymentInfo', {
                      interval: changeIntervalToText(recurring),
                    })}
                  </Text>
                </>
              ) : (
                <>
                  <Text weight="medium">One time</Text>
                  <br />
                  <Text size="small">You will be charged only once</Text>
                </>
              )}
            </Col>
          </Row>
        </Col>
      )}
      <Col span={24}>
        <Row align="middle" gutter={['ms', 0]}>
          <Col>
            <Icon icon="user-4-line" size="medium-small" />
          </Col>
          <Col>
            <Text weight="medium">{displayName ? displayInfoLabel : doNotDisplayInfoLabel}</Text>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default GivingSummaryDetails;
